/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tag/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import CloseIcon from 'DesignSystem/Svgs/CloseIcon/index'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagIcon from 'DesignSystem/TysiaTag/TysiaTagIcon/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Tag({
  children,
  viewPath = "/DesignSystem/ManualAutomations/Content/Content/ActiveAction/TaskInsertNew/Tags/Tags/Tag"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let tagNameValueData = fromData.useDataValue({ viewPath,
context: 'tag',
path: 'name',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 marginTop={dtSpaceXxxs}
 marginRight={dtSpaceXxs}
>
{childProps => (
<React.Fragment>
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 data="tag.name"
 text={tagNameValueData}
/>
<button
  data-testid="Tag.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 className={`views-block ${styles.Vertical}`}
>
<TysiaTagIcon
  viewPath={`${viewPath}/TysiaTagIcon`}
 marginLeft={dtSpaceXxs}
 marginRight={0}
>
{childProps => (
<CloseIcon
{...childProps}
  viewPath={`${viewPath}/CloseIcon`}
/>
)}
</TysiaTagIcon>
</button>
</React.Fragment>
)}
</TysiaTag>
{children}
</React.Fragment>)
}